import { Input } from '@/components/Input';
import {
    selectStorePersonName,
    setVehicleStorePersonName,
} from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';

export interface IProps {
    baseId: string;
}

export const testId = 'StorePersonName';

export function StorePersonName({ baseId }: IProps): JSX.Element {
    // ***** Redux *****
    const storePersonName = useAppSelector(selectStorePersonName);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean): void {
        if (typeof value !== 'string') return;

        dispatch(setVehicleStorePersonName(value));
    }

    // ***** Render *****
    return (
        <div data-testid={testId}>
            <Input
                title="Who's helping you today?"
                placeholder=''
                onChange={handleChange}
                id={`${baseId}-input-storePersonName`}
                value={storePersonName?.toLocaleString() ?? ''}
            />
        </div>
    );
}
